import { z } from "zod";
import { GroupBaseSchema } from "../generated/Group";
import { LotBaseSchema } from "../generated/Lot";
import { MaterialBaseSchema } from "../generated/Material";
import { getUserSchema } from "./user";

export const lotRowBaseSchama = LotBaseSchema.base.extend({
  Materials: MaterialBaseSchema.rows,
  User: getUserSchema.strip(),
});
export const lotRowsBaseSchama = z.array(lotRowBaseSchama);
export type lotRowBase = z.infer<typeof lotRowBaseSchama>;
export type lotRowsBase = z.infer<typeof lotRowsBaseSchama>;

// ロットの正規化応答(重複排除)。従来の Materials / User(Group込み)ネストを related バケットへ分離し、
// ネスト形(lotRowBase)への復元は web 側 util/hydrators/lotHydrator の共通ハイドレータが行う。
// キー名は IndexedDB の SetCache 収集キー(PascalCase 複数形)に合わせてある。
// 単一取得(get-lot-from-id)も同形(Lots 配列に1件)で返し、応答組み立てを一覧取得と共有する。
export const normalizedLotResponseSchema = z.object({
  Lots: LotBaseSchema.base.array(),
  related: z.object({
    Materials: MaterialBaseSchema.base.array(),
    // User 内の Group ネストも一般規則どおり分離する(Users は group_id 参照のみ)
    Users: getUserSchema.omit({ Group: true }).strip().array(),
    Groups: GroupBaseSchema.base.array(),
  }),
});
export type NormalizedLotResponse = z.infer<typeof normalizedLotResponseSchema>;
